<template>
  <category-page
    :category-list="categoryList"
    route-name="config-home"
    title="Configuration"
    icon="mdi-hammer-wrench"
  />
</template>

<script>
import CategoryPage from '../Common/CategoryPage'
export default {
  components: { CategoryPage },
  data () {
    return {
      categoryList: [
        {
          title: 'Fiche clients',
          description: 'Paramétrage des fiches clients',
          icon: 'mdi-folder-account',
          to: { name: 'config-client-list' },
          credentials: ['ROLE_CONFIG_CLIENT_SHOW']
        },
        {
          title: 'Tarif horaire',
          description: 'Paramétrage des tarifs horaires par client',
          icon: 'mdi-currency-eur',
          to: { name: 'config-tarif-horaire-list' },
          credentials: ['ROLE_CONFIG_TARIF_HORAIRE_SHOW']
        }
      ]
    }
  }
}
</script>
